<template>
  <div class="app-footer text-center caption white--text opacity-2">
    <p>&copy; ООО "Кассовые решения", {{ year }}</p>
  </div>
</template>
<script>
export default {
  name: "AppFooter",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style scoped>
.app-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
</style>
